<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">
        {{ copyModalHeaderName }}
      </div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <form [formGroup]="copyCustomMaterialForm" id="frmProjectCreate">
      <div id="ProjectCreateValidationSummary" class="field-validation-error"></div>
      <div>
        <div class="row">
          <div class="form-group required" aria-required="true">
            <h3 *ngIf="isStorage">Storage for 1 m<sup>3</sup>per day</h3>
            <piqet-angular-common-input
              formControlName="materialName"
              [control]="copyCustomMaterialForm.get('materialName')"
              [label]="inputFieldDesc"
              placeholder="materialName"
              [maxLength]="50"
              [submitted]="submitted"
              [errorMessages]="{
                required: (errorMessage || inputFieldDesc) + ' is required.',
                whitespace: (errorMessage || inputFieldDesc) + ' is required.'
              }"
            >
            </piqet-angular-common-input>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12" *ngIf="isHideDropDown">
            <div class="form-group required">
              <div class="services-form">
                <label>Organization </label>

                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  [searchable]="false"
                  bindLabel="name"
                  formControlName="organizationName"
                  [readonly]="true"
                  placeholder="Organization"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        style="width: 100%; line-height: 24px"
                        type="text"
                        id="inputValidation"
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer text-margin">
    <button type="button" class="btn btn-light cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
